export default {
  ASSETS_PATH: "/images/",
  BASE_URL: "https://dashboard.rcfcnr2.org/",
  MEDIA_URL: "https://dashboard.rcfcnr2.org/upload/",
};
